import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import '../../resources/css/business-card.css';
import { StoryblokService } from '../../services/storyblok';

export const BusinessCard = (): JSX.Element => {
  useEffect(() => {
    const getUrlVariables = () => {
      const vars = {};
      window.location.href
        .replace(/[?&]+([^=&]+)=([^&]*)/gi,
          (_, key, value) => { vars[key] = value; return ''; });
      return vars;
    };

    const getUrlParameter = (parameter: string, defaultValue: string) => {
      let urlParameter: string = defaultValue;
      if (window.location.href.indexOf(parameter) > -1) {
        urlParameter = getUrlVariables()[parameter];
      }
      return urlParameter;
    };

    let card: string = getUrlParameter('vcard', '');
    let hash = '';

    const elements = document.getElementsByClassName('iframe-container');
    const element = elements[0];

    if (card !== '' && card.indexOf('#') > -1) {
      const [cardWithoutHashValue, cardHashValue] = card.split('#');
      card = cardWithoutHashValue;
      hash = `#${cardHashValue}`;
    }

    if (!card) {
      element.classList.add('no-hash');
      StoryblokService.redirect();
    }

    const url = `https://businesscards.roche.com/dbc-DE-dia/${card}.html?iframe=1${hash}`;
    const iframe = document.createElement('iframe');
    iframe.setAttribute('style', 'height:100%;width:100%;border:none;overflow:hidden');
    iframe.src = url;
    iframe.id = 'dbciframe';
    iframe.scrolling = 'no';
    element.appendChild(iframe);
    const main = document?.getElementById('main');
    main?.setAttribute('style', 'margin:0');

    const resizeMessage = (e) => {
      const thisFrame = document.getElementById('dbciframe');
      if (thisFrame.contentWindow === e.source) {
        thisFrame.style.height = `${e.data.height}px`;
        window.removeEventListener('message', resizeMessage);
      }
      thisFrame.contentWindow.postMessage(e.data, 'https://businesscards.roche.com/');
    };

    window.addEventListener('message', resizeMessage);
    debounce(() => window.addEventListener('resize', resizeMessage), 250);

    return () => {
      window.removeEventListener('resize', resizeMessage);
    };
  }, []);

  return (
    <roche-grid layout="12">
      <div id="main">
        <div className="iframe-container"></div>
      </div>
    </roche-grid>
  );
};
